// extracted by mini-css-extract-plugin
export default {"specifications":"AddSpecificationModalContent-specifications-c_llu"};